import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-zinc-950 py-16 lg:py-24" aria-labelledby="faq-titulo" data-id="element-27" data-mp="1bmlnvb30w3m2">
      <div className="mx-auto max-w-3xl px-6" data-id="element-28" data-mp="1gjvj57d3f9ht">
        <h2 id="faq-titulo" className="font-display text-3xl uppercase text-white sm:text-4xl" data-id="element-29" data-mp="248o98n71an4i">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 border-t border-zinc-800" data-id="element-30" data-mp="28a9ogf71jdhv">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.pregunta} className="border-b border-zinc-800" data-id="element-31" data-mp="1zhoadcectuzd" data-mpi={index}>
                <h3 data-id="element-32" data-mp="2n8bv4y9dcf3c">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left text-white transition-colors duration-150 ease-out hover:text-amber-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400" data-id="element-33" data-mp="2n7sh3smuaaul">
                    <span className="text-base font-semibold" data-id="element-34" data-mp="19un7n81hteh3">{faq.pregunta}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-35" data-mp="19sk5xqqz9wwj" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-36" data-mp="1skd1nsxflw7y">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-37" data-mp="35yido56n1ju">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-zinc-400" data-id="element-38" data-mp="238ptalpq66h1">
                        {faq.respuesta}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}